export const LOCAL_STORAGE_KEY = { CURRENT_MODE: 'CURRENT_MODE' }
export const MODE_TYPE = {
  DARK_MODE: 'DARK_MODE',
  LIGHT_MODE: 'LIGHT_MODE',
  CUSTOM_MODE: 'CUSTOM_MODE'
}
/* for tailwind css */
export const mode_type = {
  dark: 'dark',
  light: 'light',
  custom: 'custom'
}
